module.exports = __webpack_public_path__ + "media/images/metronic/social/deviantart-a32d620a2140660addc1810395e6f625.png";